module.exports = __webpack_public_path__ + "img/a2@2x.1e70fe44.png";